import React from 'react';

export default function InvitedChip() {
  return (
    <span className="px-3 text-xs text-gray-100 bg-blue-900 rounded py-1.5">
      INVITED
    </span>
  );
};
